import { Navigate, Route, Routes } from "react-router-dom";
import { StudentAdminCertificate } from "../components/admin/StudentAdmin/Award/Certificates/Certificates";
import { StudentAdminQuests } from "../components/admin/StudentAdmin/Quests/Quests";
import { StudentAdminDashboard } from "../components/admin/StudentAdmin/Dashboard/Dashboard";
import StudentAdminEpisodes from "../components/admin/StudentAdmin/Episodes/Quests/Episodes";
import { StudentAdminMap } from "../components/admin/StudentAdmin/Map/Map";
import { StudentAdminEpisodeDetail } from "../components/admin/StudentAdmin/Episodes/Quests/EpisodeDetail/EpisodeDetail";
import { StudentAdminTrailerDetail } from "../components/admin/StudentAdmin/Episodes/Quests/TrailerDetail";
import BeginQuizesPage from "../components/admin/StudentAdmin/Quizz/BeginQuiz/BeginQuiz";
import { StudentAdminCertificateOption } from "../components/admin/StudentAdmin/Award/AwardCertificateOption";
import { StudentFestiveMap } from "../components/admin/StudentAdmin/Festival/Festive";
import { StudentAdminTrophyCongo } from "../components/admin/StudentAdmin/Congratulations/TrophyCongratulation";
import BeginQuizesPageFestive from "../components/admin/StudentAdmin/Quizz/BeginQuiz/BeginQuizFestive";
import { StudentAdminQuizzFestive } from "../components/admin/StudentAdmin/Quizz/QuizzesFestive";
import TenantProtectedRoutes from "./TenantProtectedRoutes";
import Layout from "../components/admin/StudentAdmin/layout/Layout";
import { SchoolStudentAdminQuizz } from "../components/admin/StudentAdmin/Quizz/SchoolStudentQuizzes";
import { SchlStudentAdminCongo } from "../components/admin/StudentAdmin/Congratulations/SchoolStudentCongratulation";
import { SchoolStudentQuestCertificate } from "../components/admin/StudentAdmin/Award/Certificates/SchoolStudentQuestCertificates";
import { SchoolStudentTrophy } from "../components/admin/StudentAdmin/Award/Trophy/SchlStudentTrophy";
import SchlStudentFestival from "../components/admin/StudentAdmin/Episodes/Festivals/SchlStudentFestival";
import { SchlStudentProfile } from "../components/admin/StudentAdmin/Profile/SchlStudentProfile";
import { SchlStudentProgressTracker } from "../components/admin/StudentAdmin/ProgressTracker/ProgressTracker";
import { SchlStudentNotifications } from "../components/admin/StudentAdmin/Notification/StudentNotification";
import { SchlStudentNotificationDetail } from "../components/admin/StudentAdmin/Notification/StudentNotificationDetail";

const SchoolStudentAdminRoutes = () => (
  <>
    <Routes>
      <Route
        path=""
        element={
          <TenantProtectedRoutes tenantType="student">
            <Layout userType="school-student" />
          </TenantProtectedRoutes>
        }
      >
        <Route path="start-your-quest" element={<StudentAdminDashboard />} />

        <Route path="admin/map" element={<StudentAdminMap />} />
        <Route
          path="admin/quiz/:questId/:chapterId"
          element={<SchoolStudentAdminQuizz />}
        />
        <Route
          path="admin/quiz/festive/:questId/:chapterId"
          element={<StudentAdminQuizzFestive />}
        />
        <Route
          path="admin/certificate-trophy"
          element={<StudentAdminCertificateOption />}
        />
        <Route path="admin/trophy" element={<SchoolStudentTrophy />} />
        <Route
          path="admin/certificates"
          element={<StudentAdminCertificate />}
        />
        <Route
          path="admin/certificates/:questId"
          element={<SchoolStudentQuestCertificate />}
        />

        <Route path="admin/quests" element={<StudentAdminQuests />} />
        <Route
          path="admin/quest"
          element={<Navigate to="/student/admin/quests" replace />}
        />
        <Route
          path="admin/episodes/:questId"
          element={<StudentAdminEpisodes />}
        />
        <Route
          path="admin/episodes/detail/:questId/:chapterId"
          element={<StudentAdminEpisodeDetail />}
        />
        <Route
          path="admin/episodes/festive/detail/:questId/:chapterId"
          element={<SchlStudentFestival />}
        />
        <Route
          path="admin/episode/detail/:questId"
          element={<StudentAdminEpisodeDetail />}
        />

        <Route path="festival" element={<StudentFestiveMap />} />
        <Route
          path="admin/congratulation/:chapterId/:questId"
          element={<SchlStudentAdminCongo />}
        />
        <Route
          path="admin/congratulation/trophy/:chapterId/:questId"
          element={<StudentAdminTrophyCongo />}
        />
        <Route path="admin/profile" element={<SchlStudentProfile />} />
        <Route
          path="admin/progress-tracker"
          element={<SchlStudentProgressTracker />}
        />

        <Route
          path="admin/notifications"
          element={<SchlStudentNotifications />}
        />

        <Route
          path="/admin/notification/view/:id"
          element={<SchlStudentNotificationDetail />}
        />

        <Route
          path="admin/episode/trailer/detail/:questId"
          element={<StudentAdminTrailerDetail />}
        />
        <Route
          path="admin/quiz/begin/:questId/:chapterId"
          element={<BeginQuizesPage />}
        />
        <Route
          path="admin/quiz/festive/begin/:questId/:chapterId"
          element={<BeginQuizesPageFestive />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </>
);

export default SchoolStudentAdminRoutes;
